import { Link } from 'react-router-dom';

const entries = [
  {
    type: '电影',
    icon: 'ri-film-line',
    desc: '院线新片 · 经典佳片 · 高分科幻',
    count: '1280+ 部',
  },
  {
    type: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '热播剧集 · 悬疑佳作 · 治愈日常',
    count: '960+ 部',
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 md:p-6"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500 group-hover:text-background-950 md:h-16 md:w-16">
              <i className={`${entry.icon} text-2xl md:text-3xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{entry.type}分类</h3>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                  {entry.count}
                </span>
              </div>
              <p className="mt-1 truncate text-sm text-foreground-500">{entry.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
          </Link>
        ))}
      </div>
    </section>
  );
}